import React from 'react'
import { PiSignOut } from 'react-icons/pi'
import { useAuth } from 'context/authentication/useAuth'
import { CompanyAvatar } from './CompanyAvatar'

interface ProfileMenuProps {
  onLogout: () => void
}

/**
 * Popover content for the left-nav Profile button. Header row shows the
 * company logo (with initials fallback) alongside the user's name + email;
 * footer row provides the Log out action.
 */
export const ProfileMenu: React.FC<ProfileMenuProps> = ({ onLogout }) => {
  const { user } = useAuth()
  const fullName = `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim()

  return (
    <div className="min-w-[260px]">
      <div className="flex items-center gap-3 px-3 py-2.5">
        <CompanyAvatar size={40} />
        <div className="flex flex-col gap-0.5 min-w-0">
          {fullName && (
            <p className="m-0 text-sm font-semibold text-fg leading-5 truncate">
              {fullName}
            </p>
          )}
          <p className="m-0 text-xs text-fg-secondary leading-5 break-all">
            {user?.email}
          </p>
        </div>
      </div>
      <div className="border-t border-line" />
      <div className="p-1.5">
        <button
          type="button"
          onClick={onLogout}
          className="w-full bg-transparent border-0 rounded-md hover:bg-surface-hover transition-colors text-left cursor-pointer"
        >
          <div className="flex items-center gap-3 px-3 py-1.5">
            <PiSignOut size={16} className="text-fg" />
            <span className="text-sm font-medium text-fg leading-5">
              Log out
            </span>
          </div>
        </button>
      </div>
    </div>
  )
}
